"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControllerRegistry = void 0;
const sol_did_client_1 = require("@identity.com/sol-did-client");
const constants_1 = require("../../lib/constants");
const util_1 = require("../../lib/util");
const AbstractControllerRegistry_1 = require("./AbstractControllerRegistry");
class ControllerRegistry extends AbstractControllerRegistry_1.AbstractControllerRegistry {
    constructor(wallet, connection, address, seedPrefix, cluster, payer) {
        super(address, seedPrefix, cluster);
        this.wallet = wallet;
        this.program = (0, util_1.makeProgram)(connection, wallet);
        this.payer = payer || wallet.publicKey;
    }
    initInstructionIfNeeded() {
        return __awaiter(this, void 0, void 0, function* () {
            const registryAccount = yield this.program.account.controllerRegistry.fetchNullable(this.registryAddress);
            if (registryAccount)
                return null;
            const account = this.didAddressToAccount();
            return this.program.methods
                .createControllerRegistry(this.registryBump, account.bump)
                .accounts({
                registry: this.registryAddress,
                authority: this.wallet.publicKey,
                payer: this.payer,
                did: account.authority,
                didAccount: account.account,
            })
                .instruction();
        });
    }
    resizeInstructionIfNeeded() {
        return __awaiter(this, void 0, void 0, function* () {
            const space = yield this.analyseSpace();
            // no need to resize if there is enough space, or if there is no space at all
            // (indicating the account is not yet initialised)
            if (space.count < space.maxCount || space.maxCount === 0)
                return null;
            return this.program.methods
                .resizeControllerRegistry(space.count + constants_1.SPACE_BUFFER)
                .accounts({
                registry: this.registryAddress,
                authority: this.wallet.publicKey,
                payer: this.payer,
            })
                .instruction();
        });
    }
    register(did) {
        return __awaiter(this, void 0, void 0, function* () {
            const initInstruction = yield this.initInstructionIfNeeded();
            const resizeInstruction = yield this.resizeInstructionIfNeeded();
            const preInstructions = [
                ...(initInstruction ? [initInstruction] : []),
                ...(resizeInstruction ? [resizeInstruction] : []),
            ];
            const controlledDidAccount = this.didToAccount(did);
            const didAccount = this.didAddressToAccount();
            return this.program.methods
                .registerControlledDid(didAccount.bump, controlledDidAccount.bump)
                .accounts({
                registry: this.registryAddress,
                authority: this.wallet.publicKey,
                controlledDid: controlledDidAccount.authority,
                controlledDidAccount: controlledDidAccount.account,
                didAccount: didAccount.account,
            })
                .preInstructions(preInstructions);
        });
    }
    removePubkey(did) {
        const didAccount = this.didAddressToAccount();
        return this.program.methods.removeControlledDid(didAccount.bump).accounts({
            registry: this.registryAddress,
            authority: this.wallet.publicKey,
            didToRemove: did,
            didAccount: didAccount.account,
        });
    }
    remove(did) {
        const account = this.didToAccount(did);
        return this.removePubkey(account.authority);
    }
    resize(did_count) {
        return this.program.methods.resizeControllerRegistry(did_count).accounts({
            registry: this.registryAddress,
            authority: this.wallet.publicKey,
            payer: this.payer,
        });
    }
    close() {
        const account = this.didAddressToAccount();
        return this.program.methods.closeControllerRegistry(account.bump).accounts({
            registry: this.registryAddress,
            authority: this.wallet.publicKey,
            payer: this.payer,
            did: account.authority,
            didAccount: account.account,
        });
    }
    static for(wallet, did, connection, cluster = "mainnet-beta") {
        return new ControllerRegistry(wallet, connection, sol_did_client_1.DidSolIdentifier.parse(did).authority.toBuffer(), AbstractControllerRegistry_1.CONTROLLER_REGISTRY_SEED_PREFIX, cluster);
    }
}
exports.ControllerRegistry = ControllerRegistry;
//# sourceMappingURL=ControllerRegistry.js.map